import script from "./device-form.vue?vue&type=script&setup=true&lang=tsx"
export * from "./device-form.vue?vue&type=script&setup=true&lang=tsx"

import "./device-form.vue?vue&type=style&index=0&id=764af15f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764af15f"]])

export default __exports__